import { createAction, createRequestTypes, FAILURE, REQUEST, SUCCESS } from '../../../utils/actionGenerator';

export const USER_LOGIN = createRequestTypes('USER_LOGIN');
export const SIGN_IN = 'src/App/SIGN_IN'; // static action types
export const SIGN_OUT = 'src/App/SIGN_OUT';
export const SET_LOADER = 'src/App/SET_LOADER';
export const forUser = {
  success: (response) => createAction(USER_LOGIN[SUCCESS], { response }),
  failure: (response) => createAction(USER_LOGIN[FAILURE], { response }),
  signIn: (payload) => createAction(USER_LOGIN[REQUEST], { payload }),
  signInDev: (profile, token) => createAction(SIGN_IN, { profile, token }),
  signOut: () => createAction(SIGN_OUT),
};
